import {
  API_ENDPOINT,
  type ClientApiV1FilesPostImageCreateVariables,
  useClientApiV1FilesPostImageCreateMutation,
} from '../../resources/@types/uccSchema';

function useFilePostImageCreateMutation(
  options?: Parameters<typeof useClientApiV1FilesPostImageCreateMutation>[0]['options'],
) {
  const { mutateAsync } = useClientApiV1FilesPostImageCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_FILES_POST_IMAGE,
    options,
  });

  const uploadImageForEditor = async (formData: FormData) => {
    const { data } = await mutateAsync(
      formData as unknown as ClientApiV1FilesPostImageCreateVariables,
    );

    return { url: data?.url || '' };
  };

  return {
    uploadImageForEditor,
  };
}

export default useFilePostImageCreateMutation;
